import { render, staticRenderFns } from "./Whtc.vue?vue&type=template&id=18d85085"
import script from "./Whtc.vue?vue&type=script&lang=js"
export * from "./Whtc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports